export const TRANSLATIONS_PT_HOME_QUEUE_AND_ACTIVITY = {
  "home.actionItems.eyebrow": "Ações pendentes",
  "home.actionItems.title": "Ações recomendadas",
  "home.actionItems.connection": "Sugestões para manter a fila em dia.",
  "home.actionItems.empty": "Não há ações pendentes.",
  "home.actionItems.unknownDocument": "Documento sem referência",
  "home.actionItems.due": "Vence",
  "home.smartQueue.eyebrow": "Pendências prioritárias",
  "home.smartQueue.title": "Documentos que precisam da sua revisão",
  "home.smartQueue.totalLabel": "pendentes",
  "home.smartQueue.description": "Priorizamos por risco, responsável e status de cada documento.",
  "home.smartQueue.connection": "Alimentada pelas datas críticas e pelas classificações mais recentes.",
  "home.smartQueue.metricsTitle": "Métricas operacionais (opcional)",
  "home.smartQueue.previewTitle": "Mais prioritários",
  "home.smartQueue.previewSubtitle": "Top 5",
  "home.smartQueue.previewAction": "Ver",
  "home.smartQueue.previewFilterRole": "Filtrar por papel",
  "home.smartQueue.previewViewAll": "Ver tudo",
  "home.smartQueue.status.needsReview": "Precisam da sua revisão",
  "home.smartQueue.status.processing": "Em processamento automatizado",
  "home.smartQueue.status.ready": "Prontos para publicar",
  "home.smartQueue.statusHelper.needsReview": "Exigem aprovação humana para seguir.",
  "home.smartQueue.statusHelper.processing": "A IA ainda está extraindo e classificando.",
  "home.smartQueue.statusHelper.ready": "Podem avançar para publicação ou consulta.",
  "home.smartQueue.cta": "Ver pendências",
  "home.smartQueue.tooltip": "Abrir o detalhe de todos os documentos priorizados.",
  "home.smartQueue.clearFilter": "Limpar filtro por estado",
  "home.smartQueue.panelEyebrow": "Detalhe de priorização",
  "home.smartQueue.panelTitle": "Documentos agrupados pela IA",
  "home.smartQueue.panelSubtitle": "Segmentados por status e papel disparador.",
  "home.smartQueue.closePanel": "Fechar painel de pendências",
  "home.smartQueue.badgeRole": "Ativado por papel",
  "home.smartQueue.badgeDate": "Ativado por data",
  "home.smartQueue.filterActive": "Filtro aplicado por papel ou estado.",
  "home.smartQueue.actions.snooze": "Adiar 24h",
  "home.smartQueue.actions.done": "Marcar como feito",
  "home.smartQueue.actions.assign": "Atribuir a mim",  "home.smartQueue.markAsDone": "Marcar como Concluído",
  "home.smartQueue.snooze": "Adiar",
  "home.smartQueue.recommendedAction": "Ação Recomendada",  "home.smartQueue.mutation.snoozeSuccess": "Item adiado por 24h.",
  "home.smartQueue.mutation.doneSuccess": "Item marcado como feito.",
  "home.smartQueue.mutation.assignSuccess": "Item atribuído a você.",  "home.smartQueue.mutation.reclassifySuccess": "Documento reclassificado com sucesso.",
  "home.smartQueue.reclassifyTooltip": "Re-analisar com IA",
  "home.smartQueue.reclassifyModal.title": "Reclassificar Documento",
  "home.smartQueue.reclassifyModal.reasonLabel": "Razão (obrigatória)",
  "home.smartQueue.reclassifyModal.reasonPlaceholder": "Ex: Documento classificado incorretamente como contrato",
  "home.smartQueue.reclassifyModal.correctedTypeLabel": "Tipo de classificação correto (obrigatório)",
  "home.smartQueue.reclassifyModal.correctedTypePlaceholder": "Selecione o tipo correto...",
  "home.smartQueue.reclassifyModal.originalTypeHint": "Tipo atual",
  "home.smartQueue.reclassifyModal.notesLabel": "Notas adicionais (opcional)",
  "home.smartQueue.reclassifyModal.notesPlaceholder": "Informações adicionais sobre a reclassificação...",
  "home.smartQueue.reclassifyModal.confirm": "Reclassificar",
  "home.smartQueue.reclassifyModal.cancel": "Cancelar",
  "home.smartQueue.reviewDocument": "Revisar Documento",
  "home.smartQueue.openDocument": "Abrir documento",
  "home.smartQueue.executeAction": "Executar ação",
  "home.smartQueue.mutation.actionSuccess": "Ação executada com sucesso.",  "home.smartQueue.panelEmpty": "Nenhum documento pendente.",
  "home.smartQueue.empty": "Sem pendências. Você está em dia.",
  "home.nextAction.eyebrow": "Próximo passo recomendado",
  "home.nextAction.title": "Próxima ação",
  "home.nextAction.connection": "Com base no que foi detectado hoje.",
  "home.nextAction.reason.pending_review": "Há documentos aguardando sua aprovação.",
  "home.nextAction.reason.new_documents": "Novos documentos prontos para ingestão.",
  "home.nextAction.reason.ready_to_query": "Tudo pronto para consultar o assistente.",
  "home.nextAction.reason.due_soon": "Um vencimento está próximo.",
  "home.nextAction.reason.overdue": "Um documento está vencido.",
  "home.nextAction.reason.high_priority": "Há um documento de alta prioridade.",
  "home.nextAction.reason.compliance_required": "É necessária uma ação de conformidade.",
  "home.nextAction.tooltipLabel": "Por que sugerimos isto",
  "home.nextAction.tooltip.queue": "Gerado a partir das datas detectadas e das suas pendências.",
  "home.nextAction.ack": "Reconhecer",
  "home.nextAction.cta": "Ver",
  "home.nextAction.openDocument": "Abrir documento",
  "home.nextAction.ackSuccess": "Ação confirmada.",
  "home.nextAction.empty": "Tudo certo. Nada exige sua atenção agora.",
  "home.nextAction.action.review": "Revisar",
  "home.nextAction.action.upload": "Enviar",
  "home.nextAction.action.chat": "Conversar",
  "home.nextAction.reason.needs_review": "Há documentos aguardando sua aprovação.",
  "home.lastActivity.eyebrow": "Atividade relevante",
  "home.lastActivity.title": "Mudanças recentes em decisões",
  "home.lastActivity.connection": "Mostramos apenas mudanças que afetam uma decisão ou ajudam a explicá-la.",
  "home.lastActivity.previewTitle": "O que mudou",
  "home.lastActivity.previewSubtitle": "mais recente",
  "home.lastActivity.previewAction": "Revisar",
  "home.lastActivity.markAllRead": "Marcar tudo como lido",
  "home.lastActivity.type.classification": "Classificação",
  "home.lastActivity.type.ingestion": "Ingestão",
  "home.lastActivity.type.extraction": "Extração",
  "home.lastActivity.type.normalization": "Normalização",
  "home.lastActivity.type.validation": "Validação",
  "home.lastActivity.tooltip": "Clique para ver o impacto nas prioridades.",
  "home.lastActivity.documentsImpacted": "Documentos relacionados",
  "home.lastActivity.queueImpacted": "Impacto na decisão",
  "home.lastActivity.navigateQueue": "Ver itens impactados",
  "home.lastActivity.historyLink": "Ver histórico",
  "home.lastActivity.historyEyebrow": "Registro relevante",
  "home.lastActivity.historyTitle": "Histórico de atividade",
  "home.lastActivity.closeHistory": "Fechar histórico",
  "home.lastActivity.openPanel": "Ver atividade relevante",
  "home.lastActivity.closePanel": "Fechar atividade relevante",
  "home.lastActivity.historyEmpty": "Sem eventos para mostrar.",
  "home.lastActivity.empty": "Nenhuma atividade recente.",
  "home.lastActivity.supportSignal": "Sinal de suporte",
  "home.lastActivity.event.decisionUpdated": "Decisão atualizada",
  "home.lastActivity.event.missingInformationDetected": "Informação faltante detectada",
  "home.lastActivity.event.priorityRecalculated": "Prioridade recalculada",
  "home.lastActivity.event.evidenceAdded": "Evidência adicionada",
  "home.lastActivity.event.stateChanged": "Estado alterado",
  "home.lastActivity.event.actionExecuted": "Ação executada",
  "home.lastActivity.event.supportSignal": "Atualização de suporte",
  "home.lastActivity.event.decisionUpdatedCopy": "A decisão recebeu uma mudança recente e merece uma revisão rápida.",
  "home.lastActivity.event.missingInformationDetectedCopy": "Foi detectado um dado faltante que pode bloquear a próxima ação.",
  "home.lastActivity.event.priorityRecalculatedCopy": "A prioridade mudou e pode exigir uma revisão mais rápida.",
  "home.lastActivity.event.evidenceAddedCopy": "Nova evidência chegou e a recomendação foi reavaliada.",
  "home.lastActivity.event.stateChangedCopy": "A decisão mudou de estado após uma validação recente.",
  "home.lastActivity.event.actionExecutedCopy": "A ação foi registrada e a decisão deve refletir um novo estado.",
  "home.lastActivity.event.supportSignalCopy": "Um sinal de suporte foi registrado sem alterar diretamente uma decisão visível.",
  "home.nextBestDecision.eyebrow": "Decisão protagonista",
  "home.nextBestDecision.title": "Próxima melhor decisão",
  "home.nextBestDecision.viewDecision": "Ver detalhe",
  "home.nextBestDecision.owner": "Responsável",
  "home.nextBestDecision.dueAt": "Vence em",
  "home.nextBestDecision.nextAction": "Próxima ação",
  "home.nextBestDecision.priority": "Prioridade",
  "home.nextBestDecision.priorityUnspecified": "Sem tier",
  "home.nextBestDecision.risk": "Risco",
  "home.nextBestDecision.notAvailable": "Sem dado",
  "home.nextBestDecision.confidence": "Confiança",
  "home.nextBestDecision.functionalStatus": "Ação recomendada",
  "home.nextBestDecision.recommendationCopy": "O Home IA destaca a melhor recomendação de negócio para este caso. Use as ações operacionais do detalhe para atribuir, adiar, concluir, descartar ou reavaliar.",
  "home.entityActions.toggle": "Ações da entidade",
  "home.entityActions.questionsTitle": "Perguntas sugeridas",
  "home.entityActions.questionsError": "Não foi possível carregar as perguntas.",
  "home.entityActions.questionsEmpty": "Não há perguntas sugeridas para esta entidade.",
  "home.entityActions.askAboutEntity": "Perguntar sobre esta entidade",
  "home.entityActions.askPrefill": "Fale-me sobre",
  "home.entityActions.generate": "Gerar documento",
  "home.entityActions.sourcesTitle": "Estas fontes serão usadas",
  "home.entityActions.sourcesError": "Não foi possível carregar as fontes.",
  "home.entityActions.sourcesEmpty": "Não há fontes visíveis para gerar.",
  "home.entityActions.sourcesConfirm": "Gerar com estas fontes",
  "home.entityActions.cancel": "Cancelar",
  "home.entityActions.version": "versão",
  "home.recentChanges.title": "Alterações recentes",
  "home.recentChanges.viewAll": "Ver todas",
  "home.recentChanges.empty": "Não há alterações recentes relevantes nos seus documentos.",
  "home.recentChanges.errorTitle": "Não foi possível carregar as alterações",
  "home.recentChanges.errorMessage": "Tente novamente em alguns segundos.",
  "home.nextBestDecision.urgency.critical": "Alta urgência",
  "home.nextBestDecision.urgency.high": "Importa em breve",
  "home.nextBestDecision.urgency.medium": "Acompanhar de perto",
  "home.nextBestDecision.urgency.low": "Baixa urgência",
  "home.nextBestDecision.allClear.title": "Tudo em dia",
  "home.nextBestDecision.allClear.subtitle": "Não há decisões que precisem da sua atenção agora. Um bom momento para revisar o que vem a seguir.",
  "home.nextBestDecision.allClear.navLabel": "Acessos rápidos",
  "home.nextBestDecision.allClear.reviewExpirations": "Revisar vencimentos",
  "home.nextBestDecision.allClear.viewChanges": "Ver mudanças recentes",
  "home.nextBestDecision.allClear.viewAlerts": "Ver alertas",
};
